<div class="ds-scale">
  <div *ngFor="let item of items;" class="ds-scale-item" [class.selected]="value === item" (click)="onSelect(item)">
    <span class="ds-caption-2">{{item}}</span>
  </div>
</div>
<ng-container *ngIf="showLabels">
  <div class="ds-scale-labels">
    <ng-content></ng-content>
  </div>
</ng-container>

